import React, { useRef, useState } from "react";
import { FaCloudArrowUp, FaSpinner } from "react-icons/fa6";

function LicenseDropzone({ label, uploading, hasDocs, onFile }) {
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    onFile(e.dataTransfer.files?.[0]);
  };

  return (
    <button
      type="button"
      onClick={() => !uploading && inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setDragActive(false);
      }}
      onDrop={onDrop}
      disabled={uploading}
      className={
        "w-full rounded-lg border-2 border-dashed flex flex-col items-center justify-center gap-1.5 py-6 px-4 text-sm transition-colors " +
        (dragActive
          ? "border-theme-button-primary bg-sky-50 dark:bg-sky-500/10 text-theme-button-primary"
          : "border-slate-300 dark:border-slate-600 text-slate-500 dark:text-slate-400 hover:border-theme-button-primary hover:text-theme-button-primary")
      }
    >
      {uploading ? (
        <>
          <FaSpinner className="w-5 h-5 animate-spin" />
          <span>Uploading…</span>
        </>
      ) : (
        <>
          <FaCloudArrowUp className="w-6 h-6" />
          <span className="font-medium">
            {hasDocs ? `Add another ${label}` : `Upload ${label}`}
          </span>
          <span className="text-xs">Drag &amp; drop or click · PDF or image, max 15 MB</span>
        </>
      )}
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,image/*"
        className="hidden"
        onChange={(e) => {
          onFile(e.target.files?.[0]);
          e.target.value = "";
        }}
      />
    </button>
  );
}

export default LicenseDropzone;
